import { StyledBackgroundGradient } from '@/layout/PageLayout';

import { StyledHeader, StyledHeaderContent, StyledHeaderTitle, StyledHeaderSubTitle } from './styles';

import type { ReactNode } from 'react';

interface HeaderProps {
  title?: string;
  subTitle?: string;
  emptyHeader?: boolean;
  backgroundUrl?: string;
  children?: ReactNode;
  hasNavigation?: boolean;
}

export function Header({ title, subTitle, emptyHeader, hasNavigation = true, backgroundUrl, children }: HeaderProps) {
  const Wrapper = emptyHeader ? StyledBackgroundGradient : 'div';
  return (
    <StyledHeader $emptyHeader={emptyHeader} backgroundUrl={backgroundUrl} $hasNavigation={hasNavigation}>
      <Wrapper>
        <StyledHeaderContent>
          {title && <StyledHeaderTitle $emptyHeader={emptyHeader}>{title}</StyledHeaderTitle>}
          {subTitle && <StyledHeaderSubTitle $emptyHeader={emptyHeader}>{subTitle}</StyledHeaderSubTitle>}
          {children}
        </StyledHeaderContent>
      </Wrapper>
    </StyledHeader>
  );
}
